import { render, staticRenderFns } from "./AppNavDesktop.vue?vue&type=template&id=52083a4a&"
import script from "./AppNavDesktop.vue?vue&type=script&lang=js&"
export * from "./AppNavDesktop.vue?vue&type=script&lang=js&"
import style0 from "./AppNavDesktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports